import { TEXT_GREY, GREY_BACKGROUND, LIKE_BTN_COLOR } from '@CSSVars/colors'
import { BREAK_POINT_MD } from '@CSSVars/variables'
import styled, { css } from 'styled-components'
import Flex from 'Components/Flex'
import EllipsisText from 'Components/EllipsisText'
import AppLinkMobileCtrl from 'Components/AppLinkMobileCtrl'
import ListingBanner from 'Components/ListingBanner'
import BlurCont from 'Layout/BlurCont'
import ListingSpec from 'Components/ListingSpec'


const containerCss = css`
  width: 100% !important;
  max-width: 100% !important;
  flex-basis: 100% !important;
  border-radius: inherit;
`

export const _Container = styled(AppLinkMobileCtrl)`
  ${containerCss};
`
export const _ContainerDiv = styled.div`
  ${containerCss};
`

export const _CardContent = styled(Flex)`
  width: 100% !important;
  border-radius: inherit;
  ${({ featured, multiListings }) => (
    (multiListings) && `
      border: 1px solid ${GREY_BACKGROUND};
      ${featured && 'margin-top: 14px;'}
      `
  )}
`
export const _ImageContainer = styled.div`
  width: 110px;
  height: 110px;
  position: relative;
  img {
    object-fit: cover;
    width: 110px;
    height: 110px;
  }
  span {
    line-height: 22px;
    white-space: normal;
  }
  @media screen and (max-width: 375px) {
    margin-right: 0;
    padding-right: 12px;
    width: 114px;
  }
  @media screen and (max-width: 320px) {
    margin-top: 4px;
    width: 114px;

    img {
      width: 114px;
      height: 86px
    }
  }
`
export const _ListingBanner = styled(ListingBanner)`
  width: 100%;
  font-size: 10px;
  top: auto;
  bottom: 0;
  ${({ multiListings }) => (multiListings && 'border-bottom-left-radius: 10px')};
`


export const _ListingDetail = styled.div`
  height: 100%;
  width: calc(100% - 110px);
  padding: 12px;
  flex: 1;
  align-self: center;
  position: relative;
  border-radius: 10px;
  span {
    font-size: 10px;
    line-height: 16px;
  }
  ${({ isBc }) => (isBc && `
    padding-bottom: 0;
  `)};
`

export const _Price = styled(BlurCont)`
  margin-bottom: 4px;
  line-height: 22px;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    line-height: 22px;
    font-size: 12px;
  }

  span {
    color: ${TEXT_GREY};
    font-size: 12px;
    margin-left: 2px;
    text-decoration: line-through;
  }
`

export const _Days = styled.div`
  color: ${TEXT_GREY};
  font-size: 12px;
`


export const _Title = styled(EllipsisText)`
  font-size: 12px;
  line-height: 22px;
  margin-bottom: 4px;

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    max-width: 214px;
  }
  @media screen and (max-width: 320px) {
    max-width: 176px;
  }
`

export const _InfoHolderLockContainer = styled.div`
  margin-top: 12px;
`

export const _ListingSpec = styled(ListingSpec)`
  display: block;
`


export const _ListingRemovalMessageContainer = styled.div`
  ${({ hiddenFields }) => (hiddenFields && 'margin-top: 4px;')};
`

export const _FeaturedListingIndicator = styled.div`
  background-color: ${LIKE_BTN_COLOR};
  border-radius: 6px;
  position: absolute;
  top: 0;
  left: 50%;
  height: 18px;
  translate: -50% -14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
  padding: 5px 8px 5px 5px;

  span {
    font-size: 12px;
    color: white;
  }
`
